import { useIntl } from "react-intl";
import { useWelcomeMessage } from "./use-welcome-message";
import { WelcomeMessageText } from "./WelcomeMessageText";

export function WelcomeHint() {
  const intl = useIntl();
  const { message, hintVisible, dismissHint } = useWelcomeMessage();

  if (!hintVisible) return null;

  return (
    <div id="home-welcomehint" className="smycles-hint relative mb-6">
      <button
        id="home-welcomehint-dismiss"
        type="button"
        onClick={() => void dismissHint()}
        aria-label={intl.formatMessage({ id: "home.welcomeHint.dismiss", defaultMessage: "Dismiss" })}
        className="absolute right-2 top-2 grid h-5 w-5 place-items-center rounded text-ink-muted transition hover:bg-ink/[0.08] hover:text-ink"
      >
        <svg viewBox="0 0 16 16" aria-hidden="true" className="h-3 w-3" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round">
          <path d="M4 4l8 8M12 4l-8 8" />
        </svg>
      </button>
      <WelcomeMessageText message={message} className="pr-6" idPrefix="home-welcomehint" />
    </div>
  );
}
